import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { DconConfigAPI } from "./config";
import { DataService } from "./data.service";
import { CommonServicesService } from '../services/common-services.service';

@Component({
  selector: "dcon-credentials",
  template: `<dcon-folder-details></dcon-folder-details>`,
})
export class DconCredentialsComponent implements OnInit {
  static getOrdsBaseUrl(projectFolder: any) {
    throw new Error('Method not implemented.');
  }
  public folderFetchRes: any;
  ordsBaseUrl: string;
  public tokData: any = [];
  public tokenValue: any;
  public authProjectIdValue: any;
  sftpDetails: any;
  response: any;
  constructor(
    public _httpService: CommonServicesService,
    private _data: DataService,
  ) {
  }
  ngOnInit() {

  }

  getUIPathCreds(params) {
    this.authProjectIdValue = params;
    console.log("3. callUipathVaultUrl api - dcon-creds component");
    this._httpService.callUiPathAuthApi().subscribe((resdata: any) => {
      this._data.count++;
      this.tokData = resdata?.token;
      this._data.token.next(this.tokData);
      const payload = {
        token:this.tokData,
        projectName:this.authProjectIdValue
      };
      console.log("5. callOrdsUrlAssetFetch api - dcon-creds component");
      this._httpService.callOrdsUrlAssetFetch( payload).subscribe((respdata: any) => {
        this._data.count++;
        this._data.assetFolderId.next(respdata);

        this.getOrdsCreds(this.authProjectIdValue, respdata);
      },
        (error) => {
          console.log("Error In callUipathAssetFetch" + error);
        }
      );
    },
      (error) => {
        console.log("Error In callUiPathAuthApi" + error);
      }
    );
    // this._httpService.callUipathVaultUrl(this.authProjectIdValue).subscribe((data: any) => {
    //   this._data.count++;
    //   const body = {
    //     tenancyName: DconConfigAPI.TENANCY_NAME,
    //     usernameOrEmailAddress: data.body.username,
    //     password: data.body.passkey,
    //   };
    //   this._data.uiPathCreds.username = data.body.username;
    //   this._data.uiPathCreds.passkey = data.body.passkey;
    //   console.log("4. token api - dcon-creds component");
    
    // },
    //   (error) => {
    //     console.log("Error In getUIPathCreds" + error);
    //   }
    // );
  }

  getOrdsCreds(id, res) {
    if (res != null) {
      const assetFoldId = res?.value[0].Id;
      const httpOptions = {
          token: this.tokData,
          projectName: id,
          orgId: assetFoldId.toString()
      };
      console.log("6. callKeyVaultApi api - dcon-creds component");
      this._httpService.callKeyVaultApi(id, DconConfigAPI.ORDS_CRED_ASSET).subscribe((data: any) => {
        this._data.ordstAuthData = 'Basic ' + btoa(data.body.username + ':' + data.body.passkey);
        this._data.count++;
      }, (error) => {
        console.log("Error In callKeyVaultApi" + error);
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      });
      console.log("7. callLegacyExtractStatus api - dcon-creds component");
      this._httpService.callLegacyExtractStatus(httpOptions).subscribe((data: any) => {
        if (typeof (data.value[0].Value) == "string") {
          this._data.LegacyExtract_Applicable.next(JSON.parse(data.value[0].Value.toLowerCase()));
        } else if (typeof (data.value[0].Value) == "boolean") {
          this._data.LegacyExtract_Applicable.next(data.value[0].Value);
        } else {
          this._data.LegacyExtract_Applicable.next(false);
        }
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      }, (error) => {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        console.log("Error In callAuthFolderDetails" + error);
      });
      console.log("8. callAuthFolderDetails api - dcon-creds component");
      this._httpService.callAuthFolderDetails(httpOptions).subscribe((data: any) => {
        this._data.count++;
        this._data.UI_ORDS = data.value[0].Value;
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      }, (error) => {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        console.log("Error In callAuthFolderDetails" + error);
      });
      console.log("9.1. callConfigTemplatesPath api - dcon-creds component");
      this._httpService.callConfigTemplatesPath(httpOptions).subscribe((data: any) => {
        this._data.count++;
        this._data.configTemplatePath = data.value[0].Value;
      }, (error) => {
        console.log("Error In callConfigTemplatesPath" + error);
      });
      console.log("9.2. callWindowsFIleSharePath api - dcon-creds component");
      this._httpService.callWindowsFIleSharePath(httpOptions).subscribe((data: any) => {
        this._data.count++;
        this._data.windowFileSharePath = data.value[0].Value;
      }, (error) => {
        console.log("Error In callConfigTemplatesPath" + error);
      });
      console.log("10. getSFTPDetails api - sftp configurations");
      this._httpService.getSFTPDetails(httpOptions).subscribe((details: any) => {
        this._data.count++;
        this._data.sftpPath = details[0].value[0].Value;
        this._data.sftpPort = details[1].value[0].Value;
        this._data.sftpHost = details[3].value[0].Value;
      });
      console.log("11. callKeyVaultApi api - sftp credentials ");
      this._httpService.callKeyVaultApi(id, DconConfigAPI.SFTP_CREDENTIALS).subscribe(data => {
        // console.log(data);
        this._data.sftpCredentials = btoa(data['body'].username + ':' + data['body'].passkey);
        // console.log(this._data.sftpCredentials);
        this._data.count++;
      }, (error) => {
        console.log("Error In callKeyVaultApi" + error);
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      });
    }
  }


}
